import { Box, Typography } from '@mui/material';

function CityContextBlock({ locationName, partnerCount }) {
  if (!partnerCount) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: -5, mb: 1.5 }}>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          bgcolor: 'common.white',
          color: 'primary.main',
          border: '1px solid',
          borderColor: 'primary.main',
          borderRadius: 1,
          px: 1.5,
          py: 0.5,
        }}>
        <Typography variant="caption" fontWeight={700} color="inherit">
          {partnerCount} Vermietpartner im Raum {locationName}
        </Typography>
      </Box>
    </Box>
  );
}

export default CityContextBlock;
